// removed by extract-text-webpack-plugin
module.exports = {"content":"c-EmptyBagInfo__content","message":"c-EmptyBagInfo__message","bottom":"c-EmptyBagInfo__bottom","link":"c-EmptyBagInfo__link"};